{
  "es": {
    "task": {
      "actions": {
        "create": "Tarea",
        "create_and_send": "Crear y enviar",
        "delete": "Eliminar tarea",
        "open_in_project": "Abrir la tarea en el proyecto",
        "remove_from_unit": "Quitar la tarea de esta unidad",
        "save_as_draft": "Guardar como borrador",
        "update": "Editar tarea"
      },
      "attributes": {
        "assignments_count": "Asignaciones",
        "category": "Forma de completar",
        "created_at": "Creado",
        "description": "Descripción",
        "phase": "Fase",
        "title": "Título",
        "units": "Unidades"
      },
      "categories": {
        "confirmation": "Confirmación",
        "upload": "Subida de documento"
      },
      "categories_info": {
        "confirmation": "La persona asignada marca la tarea cuando está hecha.",
        "upload": "La persona asignada tiene que subir un documento para completar la tarea."
      },
      "confirm": {
        "delete_body": "La tarea desaparece, y todas sus asignaciones también: {assignments} en {units}.",
        "delete_header": "¿Eliminar «{title}»?",
        "delete_silent": "No se notifica a nadie, y las notificaciones ya enviadas no se retiran.",
        "remove_from_unit_body": "Cada responsable de «{title}» en {unit} la pierde. La tarea y sus otras unidades quedan igual.",
        "remove_from_unit_customers": "Los clientes de {unit} dejan de verla en su portal.",
        "remove_from_unit_header": "¿Quitar esta tarea de {unit}?"
      },
      "deep_link": {
        "show_all": "Mostrar todas las tareas",
        "single": "Estás viendo una tarea de una notificación."
      },
      "empty": {
        "filtered_description": "Ajusta tus filtros o bórralos para ver todas las tareas.",
        "filtered_title": "Ninguna tarea coincide con tus filtros",
        "none_title": "Sin tareas"
      },
      "filters": {
        "phase_none": "Sin fase"
      },
      "labels": {
        "assignments_count": "{count} asignación | {count} asignaciones",
        "created_by": "Creado por {name} · {date}",
        "created_on": "Creado el {date}",
        "no_tasks": "Todavía no hay tareas para este proyecto.",
        "required": "Este campo es obligatorio",
        "set_all_assignees": "Aplicar al responsable | Aplicar a los {count} responsables",
        "still_to_do": "{count} pendiente | {count} pendientes",
        "units_count": "{count} unidad | {count} unidades",
        "units_required": "Selecciona al menos una unidad"
      },
      "toasts": {
        "create": "Tarea creada",
        "delete": "Tarea eliminada",
        "remove_from_unit": "Tarea quitada de esta unidad",
        "update": "Tarea actualizada"
      }
    }
  }
}
